import React, { useState } from 'react'
import SignUp from './SignUp'
import ReadyToShop from './ReadyToShopNewUser'


const SignUpDisplay=(props)=>{
    
    // if(props.display === 'hii')
        // console.log(props);
    const [currentDisplay, setCurrentDisplay] =useState(<SignUp/>)
    // const [currentDisplay, setCurrentDisplay] =useState(<ReadyToShop/>)
    
    const [isSignUp, setIsSignUp] = useState(props.isSignUp)


    return(
        <>

            {currentDisplay}
            {/* {
                isSignUp
                ? <ReadyToShop/>
                : <SignUp/> 
            } */}
        </>
    )
}

export default SignUpDisplay